import { ApiAction, ApiSuccessAction } from 'lib/types/global';
import {
  DELETE_USER_REQUEST,
  GET_MORE_USERS_REQUEST,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_ODC_USERS_REQUEST,
  GET_ODC_USERS_SUCCESS,
  GET_ODC_USERS_FAILURE,
  GET_MORE_USERS_SUCCESS,
  GET_USER_SUCCESS,
  UPDATE_USER_ROLE_REQUEST,
  UPDATE_USER_ROLE_SUCCESS,
  UPDATE_USER_ROLE_FAILURE,
  RESET_EMPLOYEE_STATE,
  LOGOUT_SUCCESS,
  RESET_ODC_USERS_STATE,
} from './actionTypes';

export type EmployeesPayload = {
  result: [];
  // eslint-disable-next-line camelcase
  total_count: number;
};

export type ODCUserPayload = {
  anonymized_user_id: string;
  name: string;
  username: string;
  role: string;
  branch_drn: string;
  branch_drn_id: string;
  security_principal_id: string;
  security_principal_drn: string;
  market: string;
};

type ApiDeleteUserRequest = ApiAction<DELETE_USER_REQUEST>;
type ApiGetMoreUsersRequest = ApiAction<GET_MORE_USERS_REQUEST>;
type ApiGetUsersRequest = ApiAction<GET_USERS_REQUEST>;
type ApiGetODCUsersRequest = ApiAction<GET_ODC_USERS_REQUEST>;
type ApiGetUsersSuccess = ApiSuccessAction<GET_USERS_SUCCESS, EmployeesPayload>;
type ApiGetMoreUsersSuccess = ApiSuccessAction<
  GET_MORE_USERS_SUCCESS,
  EmployeesPayload
>;
type ApiGetUserSuccess = ApiSuccessAction<GET_USER_SUCCESS>;
type ApiGetODCUsersSuccess = ApiSuccessAction<
  GET_ODC_USERS_SUCCESS,
  ODCUserPayload[]
>;
type ApiGetODCUsersFailure = ApiAction<GET_ODC_USERS_FAILURE>;
type ApiResetODCUsersState = ApiAction<RESET_ODC_USERS_STATE>;
type ApiUpdateUserRoleRequest = ApiAction<UPDATE_USER_ROLE_REQUEST>;
type ApiUpdateUserRoleSuccess = ApiSuccessAction<UPDATE_USER_ROLE_SUCCESS>;
type ApiUpdateUserRoleFailure = ApiAction<UPDATE_USER_ROLE_FAILURE>;
type ApiResetEmployeeState = ApiAction<RESET_EMPLOYEE_STATE>;
type ApiLogoutSuccess = ApiAction<LOGOUT_SUCCESS>;

export type UsersAction =
  | ApiDeleteUserRequest
  | ApiGetMoreUsersRequest
  | ApiGetUsersRequest
  | ApiGetODCUsersRequest
  | ApiGetODCUsersSuccess
  | ApiGetODCUsersFailure
  | ApiResetODCUsersState
  | ApiGetUsersSuccess
  | ApiGetMoreUsersSuccess
  | ApiGetUserSuccess
  | ApiUpdateUserRoleRequest
  | ApiUpdateUserRoleSuccess
  | ApiUpdateUserRoleFailure
  | ApiResetEmployeeState
  | ApiLogoutSuccess;

type ForgottenPasswordParams = { email: string };
const forgottenPassword = ({ email }: ForgottenPasswordParams) => ({
  endpoint: '/api/request-password-reset',
  type: 'FORGOTTEN_PASSWORD',
  options: {
    method: 'POST',
    body: {
      email,
    },
  },
});

type ResetPasswordParams = {
  password1: string;
  password2: string;
  token: string;
};
const resetPassword = ({
  password1,
  password2,
  token,
}: ResetPasswordParams) => ({
  endpoint: '/api/reset-password',
  type: 'RESET_PASSWORD',
  options: {
    method: 'POST',
    body: {
      password: password1,
      password_confirmation: password2,
      reset_token: token,
    },
  },
});

export { forgottenPassword, resetPassword };
